<template>
  <div class="mt-2">
    <VLayout
      wrap
      justify-center
    >
      <RouterLink
        v-for="(service, index) in services"
        :key="index"
        :to="{ name: 'Services', params: { slug: service.slug } }"
      >
        <div class="box">
          <img
            :src="require(`@/assets/${service.icon}`)"
            style="width: 62px; color: white; margin-top: 50px;"
            :alt="service.title"
          >

          <div
            class="font-weight-bold subheading"
            style="width: 230px; margin: 20px auto 0 auto;"
          >
            {{ service.title }}
          </div>
        </div>
      </RouterLink>
    </VLayout>

    <div
      class="mb-5 text-xs-center"
      style="margin-top: 60px;"
    >
      <div
        class="pacifico primary--text"
        style="font-size: 26px;"
      >
        Szolgáltatások
      </div>

      <div
        class="mt-2 font-weight-bold display-2 serviceTitle"
        style="color: #212121;"
      >
        {{ selectedService.title }}
      </div>

      <VLayout
        v-if="selectedService.subServices"
        class="mt-5"
        style="max-width: 1200px; margin: auto;"
        justify-center
        wrap
      >
        <VCard
          v-for="(subService, index) in selectedService.subServices"
          :key="index"
          width="300px"
          flat
          class="ma-4 serviceCard"
        >
          <RouterLink
            :to="{
              name: 'SubServices',
              params: {
                serviceSlug: selectedService.slug,
                subServiceSlug: subService.slug
              }
            }"
          >
            <VImg
              :src="require(`@/assets/service-photos/${subService.slug}-thumb.jpg`)"
            />
          </RouterLink>

          <VCardTitle
            primary-title
            class="px-0"
          >
            <div class="text-xs-left">
              <RouterLink
                :to="{
                  name: 'SubServices',
                  params: {
                    serviceSlug: selectedService.slug,
                    subServiceSlug: subService.slug
                  }
                }"
                class="black--text"
              >
                <h2 class="title font-weight-bold">
                  {{ subService.title }}
                </h2>
              </RouterLink>

              <div
                class="mt-3"
                style="color: #757575;"
                v-html="subService.text"
              />
            </div>
          </VCardTitle>
        </VCard>
      </VLayout>

      <div
        v-else-if="selectedService.serviceList"
        class="mt-4"
        style="width: 1600px; max-width: 95vw; margin: auto;"
      >
        <div
          class="text mb-4"
          v-html="selectedService.text"
        />

        <VChip
          v-for="(serviceName, index) in selectedService.serviceList"
          :key="index"
          color="primary"
          text-color="white"
          label
          class="font-weight-medium"
          style="height: 45px; font-size: 14px; text-transform: uppercase;"
        >
          {{ serviceName }}
        </VChip>

        <div class="mt-5 text-xs-center">
          <img
            src="@/assets/service-photos/reklamanyag-gyartas.jpg"
            style="width: 1000px; max-width: calc(100vw - 32px);"
            alt="Reklámanyagok"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import servicesData from '@/data/services.json';

export default {
  name: 'Services',
  metaInfo() {
    const { title, text } = this.selectedService;

    return {
      title: `${title} | Körös PRINT-PACK Kft.`,
      meta: [
        {
          name: 'description',
          content: text && text.length > 117 ? `${text.slice(0, 116)}...` : text,
        },
      ],
    };
  },
  data: () => ({
    services: servicesData,
  }),
  computed: {
    selectedService() {
      const { services } = this;
      const { slug: selectedSlug } = this.$route.params;

      const selectedService = services.find(({ slug }) => slug === selectedSlug);

      if (!selectedService && this.$route.name === 'Services') {
        this.$router.replace({ name: 'Services', params: { slug: 'dobozgyartas' } });

        return services.find(({ slug }) => slug === 'dobozgyartas');
      }

      return selectedService;
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.box {
  width: 500px;
  min-height: 200px;
  max-width: 95vw;
  text-align: center;
  background-color: #b0bec5;
  color: white;
  line-height: 1.3;
  margin: 5px;
}

.box:hover {
  background-color: #008179;
}

.router-link-active div {
  background-color: #008179;
}

@media (max-width: 600px) {
  .serviceCard {
    margin: 5px 0 5px 0 !important;
  }
}

.text {
  font-size: 18px;
  color: #757575;
  line-height: 1.8;
  width: 1400px;
  max-width: 90vw;
  margin: auto;
  font-weight: 300;
}

.serviceTitle {
  line-height: 1 !important;
}

@media (max-width: 959px) {
  .serviceTitle {
    font-size: 32px !important;
  }
}
</style>
